/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Module_Settings_Delete_TitleInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete {name}?" |
*
* @param {Module_Settings_Delete_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const module_settings_delete_title = /** @type {((inputs: Module_Settings_Delete_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Settings_Delete_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Are you sure you want to delete ${i?.name}?`)
	return /** @type {LocalizedString} */ (`Êtes-vous sûr de vouloir supprimer ${i?.name} ?`)
});